// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uins-docs{font-family:LatoWebLight,Arial,sans-serif,Helvetica;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50;margin:1em auto 0 auto;padding:0;max-width:860px}.uins-docs,.uins-docs .bg{position:relative;display:block;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;width:100%}.uins-docs .bg{padding:2em .25em 1em .25em;background:#f4f4f8}", ""]);
// Exports
module.exports = exports;
